/*
 * TopNav Messages
 *
 * This contains all the text for the TopNav component.
 */

import { defineMessages } from 'react-intl';

export const scope = 'app.components.TopNav';

export default defineMessages({
  tours: {
    id: `${scope}.tours`,
    defaultMessage: 'Tours'
  },
  dashboard: {
    id: `${scope}.dashboard`,
    defaultMessage: 'Dashboard'
  },
  manifest: {
    id: `${scope}.manifest`,
    defaultMessage: 'Manifest'
  },
  balance: {
    id: `${scope}.balance`,
    defaultMessage: 'Balance'
  },
  payments: {
    id: `${scope}.payments`,
    defaultMessage: 'Payments'
  },
  settings: {
    id: `${scope}.settings`,
    defaultMessage: 'Settings'
  },
  bookings: {
    id: `${scope}.bookings`,
    defaultMessage: 'Bookings'
  },
  resources: {
    id: `${scope}.resources`,
    defaultMessage: 'Resources'
  },
  channelManager: {
    id: `${scope}.channel_manager`,
    defaultMessage: 'Channel Manager'
  },
  promotions: {
    id: `${scope}.promotions`,
    defaultMessage: 'Promotions'
  },
  tipdirect: {
    id: `${scope}.tipdirect`,
    defaultMessage: 'Get Tips'
  },
  profile: {
    id: `${scope}.profile`,
    defaultMessage: 'Profile'
  },
  reviews: {
    id: `${scope}.reviews`,
    defaultMessage: 'Reviews'
  },
  // Card 305 — guide-facing tour photo capture.
  tourPhotos: {
    id: `${scope}.tourPhotos`,
    defaultMessage: 'Tour Photos'
  },
  // Card 324 — head office's guest feedback page.
  guestFeedback: {
    id: `${scope}.guestFeedback`,
    defaultMessage: 'Guest Feedback'
  },
  // Card 323 — the guide's guest feedback QR.
  feedbackQr: {
    id: `${scope}.feedbackQr`,
    defaultMessage: 'Feedback QR'
  },
  // Card 296 — the mobile menu's Product Improvement (PIP) entry.
  productImprovement: {
    id: `${scope}.productImprovement`,
    defaultMessage: 'Product Improvement'
  },
  // Card 288 — guest review replies and moderation. PROTOTYPE.
  guestReviews: {
    id: `${scope}.guestReviews`,
    defaultMessage: 'Guest Reviews'
  },
  signOut: {
    id: `${scope}.sign_out`,
    defaultMessage: 'Sign Out'
  },
  recommendToAFriend: {
    id: `${scope}.recommend_to_a_friend`,
    defaultMessage: 'Recommend To A Friend'
  },
  companyInvite: {
    id: `${scope}.companyInvite`,
    defaultMessage: 'Company Invite'
  },
  setup: {
    id: `${scope}.setup`,
    defaultMessage: 'Setup'
  },
  takePayments: {
    id: `${scope}.takePayments`,
    defaultMessage: 'Take Payments'
  },
  messaging: {
    id: `${scope}.messaging`,
    defaultMessage: 'Messaging'
  },
  getReviews: {
    id: `${scope}.getReviews`,
    defaultMessage: 'Get Reviews'
  }
});
